import dayjs from "dayjs";
import { sortGrid } from "../sortGrid";

const adaptStoreReport = (storeReport: IStoreReport[]) => {
	const flatData: any = {};

	storeReport.forEach((storeReport: IStoreReport) => {
		// new row, create a new object
		if (flatData[`k_${storeReport.store_id}`] === undefined) {
			flatData[`k_${storeReport.store_id}`] = {};

			flatData[`k_${storeReport.store_id}`]["storeName"] =
				storeReport.store_name;

			flatData[`k_${storeReport.store_id}`]["storeId"] = storeReport.store_id;
		}

		const key = dayjs()
			.month(storeReport.month - 1)
			.format("MMM");

		flatData[`k_${storeReport.store_id}`][key] = {
			complete: storeReport.complete_count,
			compliant: storeReport.compliant_count,
			passedThreshold: storeReport.store_threshold_count,
			month: storeReport.month,
			graded: storeReport.graded_count,
			totalUserCount: storeReport.total_user_count
		};
	});

	// Flatten the data
	const data = Object.keys(flatData).map((key) => flatData[key]);

	sortGrid(data, "name");

	return data;
};

export default adaptStoreReport;
